import { useTranslation } from 'next-i18next';
import { ThreadsDownloaderContentData } from './types';
import { useMemo } from 'react';

// 静态内容数据
const useThreadsDownloaderStaticContentData = () => {
  const { t } = useTranslation();

  const staticContentData = useMemo(
    () =>
      ({
        contentInfo: {
          'section-0': {
            cards: [
              {
                imgPath: '/images/threads-downloader/td-step-3.webp',
                title: t('Step1: Get the Link'),
                desc: t(
                  'Open the Threads post you want to download. Tap the three-dot ... menu and select “Copy link.”'
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-step-2.webp',
                title: t('Step2: Paste to Analyze'),
                desc: t(
                  "Paste the link into the input box on our site and click Download. We'll process the link in seconds."
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-step-1.webp',
                title: t('Step3: View & Save Content'),
                desc: t(
                  'Once processed, you can preview and download the video, image, or GIF directly in high quality.'
                ),
              },
            ],
            title: t('How to Use This Threads Downloader'),
            desc: '',
          },
          'section-2': {
            imgPath: '/images/threads-downloader/td-why-1.webp',
            parts: [
              {
                imgPath: '/images/threads-downloader/td-why-download-icon.webp',
                title: t("Threads Doesn't Support Downloads"),
                desc: t(
                  "Threads doesn't let you download videos, GIFs, or images directly from the app. Without a downloader, you're limited to viewing content only within the Threads platform."
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-why-user-icon.webp',
                title: t('Posts Can Be Edited or Deleted Anytime'),
                desc: t(
                  'Content on Threads can disappear from your feed or be removed by the creator. Without a downloader, you risk losing access to media you care about.'
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-why-data-icon.webp',
                title: t('No Offline Access'),
                desc: t(
                  "Whether you're traveling, on limited data, or just want to watch later, downloading ensures you can access your favorite media without an internet connection."
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-why-media-icon.webp',
                title: t('Use Content Beyond Threads'),
                desc: t(
                  'Downloaded videos, images, or GIFs can be reused on other platforms, shared privately, or stored for future projects. A downloader gives you full control over the media you access.'
                ),
              },
            ],
            title: t('Why Use a Threads Video Downloader?'),
            desc: '',
          },
          'section-3': {
            cards: [
              {
                imgPath: '/images/threads-downloader/td-key-download-icon.webp',
                title: t('Download Multiple Videos from a Single Post'),
                desc: t(
                  'Threads often feature carousels or posts with multiple videos. Our downloader automatically detects and fetches each one, so you can save all media from a single link in just one click.'
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-key-device-icon.webp',
                title: t('Supports All Threads Media Types'),
                desc: t(
                  "Whether it's a short-form video, a looping GIF, or an image, our Threads downloader handles them all — giving you full flexibility over what to save."
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-key-preview-icon.webp',
                title: t('Preview Threads Posts Instantly'),
                desc: t(
                  'Paste a Threads link to instantly view the full post — including all videos, GIFs, or images. Each file is clearly labeled and shown in order, ready to preview or download in HD.'
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-key-free-icon.webp',
                title: t('Fast and 100% Free'),
                desc: t(
                  'Unlike many browser extensions or spammy apps, Dolphin Radar runs in your browser with no extensions and no tracking. Just a simple, secure way to download Threads content whenever you need it.'
                ),
              },
            ],
            title: t("Key Features of Dolphin Radar's Threads Downloader"),
            desc: '',
          },
          'section-4': {
            cards: [
              {
                imgPath: '/images/threads-downloader/td-who-save-icon.webp',
                title: t("Save Content You Don't Want to Lose"),
                desc: t(
                  "Threads posts can be edited, deleted, or lost in the feed. Whether it's your own video or someone else's, downloading ensures you have a copy that won't vanish."
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-who-circle-icon.webp',
                title: t('Reuse and Repurpose Media'),
                desc: t(
                  'Creators and marketers often need to reuse content on other platforms or in edits. Our downloader makes it easy to grab high-quality versions for republishing or remixing.'
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-who-offline-icon.webp',
                title: t('Stay Productive Offline'),
                desc: t(
                  'Need to prep for a presentation, edit a clip on the go, or just kill time on a flight? Downloaded videos and GIFs give you access anywhere, even without internet.'
                ),
              },
              {
                imgPath: '/images/threads-downloader/td-who-download-icon.webp',
                title: t('Download Privately for Personal Use'),
                desc: t(
                  "Sometimes you want to save content for your own reference — whether it's funny, emotional, or personal. Threads Downloader makes it easy to download Threads videos or GIFs discreetly."
                ),
              },
            ],
            title: t('Who Can Benefit from Using This Threads Downloader'),
            desc: '',
          },
          'section-buttom': {
            title: t('Download Threads Videos, GIFs, and Images Instantly'),
            desc: t("Try Dolphin Radar — it's free, fast, and lets you download Threads media in just one click."),
          },
        },
      }) as ThreadsDownloaderContentData,
    []
  );

  return { staticContentData };
};

export default useThreadsDownloaderStaticContentData;
